import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'
import ParamsUtil from 'utils/params-util'

const API_PATH = 'api/v2/admins/customers/refunds'

const CustomerRefundsApiV2 = {
  /**
   * Create Customer Refund from single Order Item
   * @param {object} selectedOrderItem - Selected Order Item to be refunded
   * @param {object} values - FormikBag values
   */
  create: async ({ selectedOrderItem, values }) => {
    const payload = {
      refund: {
        ...values,
        order_item: {
          id: selectedOrderItem.id
        }

      }
    }

    const response = axios.post(API_PATH, payload)
    return response
  },

  /**
   * Get list of Customer Refunds
   * Invoke `GET api/v2/admins/customers/refunds
   */
  get: async ({
    page              = 1,
    per_page          = 10,
    number            = '',
    refund_method     = '',
    status            = '',
    product_sku       = '',
    initiated_by      = '',
    created_at_from   = '',
    created_at_to     = '',
    resolution_action = '',
    resolution_status = ''
  }) => {
    let params = {
      page              : page,
      per_page          : per_page,
      number            : number,
      refund_method     : refund_method,
      status            : status,
      product_sku       : product_sku,
      initiated_by      : initiated_by,
      created_at_from   : created_at_from,
      created_at_to     : created_at_to,
      resolution_action : resolution_action,
      resolution_status : resolution_status
    }

    params = ParamsUtil.removeEmptyAttributes(params)

    const response = axios.get(API_PATH, { params })
    return response
  },

  /**
   * Get Customer Refund shippable, where
   * - status is `rejected`
   * - not have Customer Refund Shipment
   * - Intiated by ops before shipping or customer service
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  shippable: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/shippable`

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get refund request detail.
   * Invoke `GET api/v2/admins/customers/refunds/:id`
   * @param {number} id - Order ID
   */
  show: async (
    id
  ) => {
    const path = `${API_PATH}/${ id }`

    const response = axios.get(path)
    return response
  },

  /**
   * Update refund attributes.
   * Invoke `PATCH api/v2/admins/customers/orders/refunds/:id`
   * @param {number} id - Order ID
   * @param {obj} params - attribute to update refund can be (refund_method, cs_notes or ops_notes)
   */
  update: async (
    id,
    params
  ) => {
    const path = `${API_PATH}/${ id }`

    const body     = params
    const response = axios.patch(path, body)
    return response
  },

  /**
   * Update customer refund status to be accepted
   * Invoke `PATCH api/v2/admins/customers/refunds/:id/accept`
   * @param {number} id - Customer Refund ID
   * @param {object} payload - choosed refund method to accept the customer refund and resolution action to accept the customer refund
   */
  accept: async (
    id,
    payload
  ) => {
    const path = `${API_PATH}/${ id }/accept`

    // payload = {
    //   refund_method     : string,
    //   resolution_action : string
    // }
    const response = axios.patch(path, payload)
    return response
  },

  /**
   * Update customer refund status to be rejected
   * Invoke `PATCH api/v2/admins/customers/refunds/:id/reject`
   * @param {number} id - Order ID
   * @param {object} payload - selected reject reason to reject the refund request
   */
  reject: async (
    id,
    payload
  ) => {
    const path = `${API_PATH}/${ id }/reject`

    // payload = {
    //   reject_reason: string
    //   ops_notes: string // optional
    //   cs_notes: string // optional
    // }
    const response = axios.patch(path, payload)
    return response
  },

  /**
   * Update customer refund item location
   * Invoke `PATCH api/v2/admins/customers/refunds/:id/back_to_location`
   * @param {number} id - Customer Refund ID
   * @param {number} location_id - selected warehouse location id
   */
  backToLocation: async ({
    id,
    location_id
  }) => {
    const path = `${API_PATH}/${ id }/back_to_location`

    const payload  = {
      location_id: location_id
    }
    const response = axios.patch(path, payload)
    return response
  },

  /**
   * Create or Update customer bank account details.
   * Invoke `PATCH api/v2/admins/customers/refunds/:id/customer_bank`
   * @param {object} params - object of body
   */
  customerBankUpdate: async (
    id,
    params
  ) => {
    const path = `${API_PATH}/${ id }/customer_bank`

    // params = {
    // name: string
    // holder_name: string
    // account_number: string
    // branch: string
    //}
    const response = axios.patch(path, params)
    return response
  }
}

export default CustomerRefundsApiV2
